import {gql} from '@apollo/client';

import {TaxFreeChildcareChild} from 'web-app/react/bookings-finance/graphql/tax-free-childcare-child.fragment';

export default gql`
    fragment PaymentsSource on PaymentsSource {
        id
        type
        title
        expiryYear
        expiryMonth
        lastDigits
        active
        status
        enabledIn
        paymentMethodId
        taxFreeChildcare {
            children {
                ...TaxFreeChildcareChild
            }
        }
        behaviors {
            behaviorId
            __typename
            ... on BehaviorAutomaticPayments {
                billPayers {
                    billPayerId
                    name
                    institutionId
                }
            }
        }
    }
    ${TaxFreeChildcareChild}
`;
